import { render, staticRenderFns } from "./WelcomeEmailComponent.vue?vue&type=template&id=dab39d48&scoped=true"
import script from "./WelcomeEmailComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeEmailComponent.vue?vue&type=script&lang=js"
import style0 from "./WelcomeEmailComponent.vue?vue&type=style&index=0&id=dab39d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab39d48",
  null
  
)

export default component.exports